import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { UserManagementService } from "src/app/contract/shared/user-management.service";
import { UserService } from "src/app/shared/user.service";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort, Sort } from "@angular/material/sort";
import { ToastrService } from "ngx-toastr";
import * as moment from "moment";
import { DeleteDialogComponent } from "../../delete-dialog/delete-dialog.component";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-role-list",
  templateUrl: "./role-list.component.html",
  styleUrls: ["./role-list.component.css"],
})
export class RoleListComponent implements AfterViewInit {
  constructor(
    public usermanagementService: UserManagementService,
    public userService: UserService,
    public toast: ToastrService,
    private dialog: MatDialog
  ) {
    this.getRolesData();
  }

  // Table columns
  displayedColumns: string[] = ["Role Name", "Created By", "Last Updated", "Status", "Action"];

  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  isLoading: { [key: string]: boolean } = {};


  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  ngOnInit(): void { }

  async toggleRoleStatus(data) {
    this.isLoading[data.id] = true;
    // data.status = data.status === 1 ? 0 : 1;
    await this.usermanagementService.updateRole().then((res) => {
      this.toast.success(data.name + ' status has been updated successfully!', '');
      this.getRolesData(data.id);
    });
  }

  async getRolesData(id = null) {
    await this.usermanagementService.getAllRoles().then((allRoles: any) => {

      allRoles.forEach((data: any) => {
        data.updateDate = moment(data.updateDate).format('lll');
      });


      this.dataSource.data = allRoles;
    });

    this.isLoading[id] = false;

    if (this.sort) {
      this.dataSource.sort = this.sort;
      this.dataSource.sort.active = 'Last Updated';
      this.dataSource.sort.direction = 'desc';
      this.customSortData({
        active: 'Last Updated',
        direction: 'desc'
      } as Sort);
    }
  }

  // openDeleteConfirmation(id): void {
  //   const dialogRef =
  //     this.dialog.open(DeleteDialogComponent, {
  //       enterAnimationDuration: '400ms',
  //       exitAnimationDuration: '500ms',
  //       data: {
  //         deleteFunction: () => this.delete(id, dialogRef)
  //       }
  //     });
  // }

  // async delete(id: number, dialogRef: MatDialogRef<DeleteDialogComponent>) {
  //   try {
  //     await this.usermanagementService.deleteRole(id);
  //     this.toast.success('The role has been deleted successfully!', '');
  //     this.getRolesData();
  //     dialogRef.close();
  //   } catch (error) {
  //     this.toast.error('Failed to delete the role!', 'Error');
  //   }
  // }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  customSortData(event: Sort) {
    const data = this.dataSource.data.slice();
    if (!event.active || event.direction === '') {
      this.dataSource.data = data;
      return;
    }

    this.dataSource.data = data.sort((a, b) => {
      const valueA = (a[event.active] || '').toString().toLowerCase();
      const valueB = (b[event.active] || '').toString().toLowerCase();

      return this.compare(valueA, valueB, event.direction === 'asc');
    });

    if (this.paginator) {
      this.paginator.firstPage();
    }
  }

  compare(a: string, b: string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

}
// import { Component, OnInit, ViewChild } from '@angular/core';
// import { UserManagementService } from 'src/app/contract/shared/user-management.service';
// import { Router, ActivatedRoute } from '@angular/router';
// import { UserService } from 'src/app/shared/user.service';
// import { MatPaginator } from '@angular/material/paginator';
// import { MatSort, Sort } from '@angular/material/sort';
// import { MatTableDataSource } from '@angular/material/table';
// import { DeleteDialogComponent } from '../../delete-dialog/delete-dialog.component';
// import { MatDialog } from '@angular/material/dialog';
// import * as moment from 'moment';
// import { ToastrService } from 'ngx-toastr';

// @Component({
//   selector: "app-role-list",
//   templateUrl: "./role-list.component.html",
//   styleUrls: ["./role-list.component.css"],
// })
// export class RoleListComponent implements OnInit {
//   displayedColumns: string[] = [
//     "Role Name",
//     "Created By",
//     // "Contact Number",
//     // "Email Address",
//     "Last Updated",
//     "Status",
//     "Action",
//   ];

//    dataSource = new MatTableDataSource<any>();
//     @ViewChild(MatPaginator) paginator: MatPaginator;
//     @ViewChild(MatSort) sort: MatSort;
//     isLoading: { [key: string]: boolean } = {};
    
//   constructor(
//     public usermanagementService: UserManagementService,
//     private router: Router,
//     private route: ActivatedRoute,
//     public userService: UserService,
//     private dialog: MatDialog,
//     public toast: ToastrService,
//   ) {}

//   ngAfterViewInit(): void {
//     this.dataSource.paginator = this.paginator;
//     this.dataSource.sort = this.sort
//   }

//   ngOnInit(): void {
//     this.getAllRoles();
//     const loaderElement = document.getElementById('loader');
//     if (loaderElement) {
//       loaderElement.style.display = 'block';
//     }

//     this.usermanagementService.getAllRoles().then((res) => {
//       if (loaderElement) {
//         loaderElement.style.display = 'none';
//       }
//       if (this.usermanagementService.userCreationConfirmationAlert) {
//         const roleCreatedElement = document.getElementById('roleCreated');
//         if (roleCreatedElement) {
//           roleCreatedElement.style.display = 'block';
//         }
//         this.usermanagementService.userCreationConfirmationAlert = false;
//       }
//     });
//   }

//   async getAllRoles(id = null) {
//       await this.usermanagementService.getAllRoles().then((res: any) => {
//         res.forEach((user: any) => {
//           user.updateDate = moment(user.updateDate).format('lll');
//         });
//         this.dataSource.data = res;
//       });
//       if (id)
//         this.isLoading[id] = false;
  
//       if (this.sort) {
//         this.dataSource.sort = this.sort;
//         this.dataSource.sort.active = 'Last Updated';
//         this.dataSource.sort.direction = 'desc';
//         this.customSortData({
//           active: 'Last Updated',
//           direction: 'desc'
//         } as Sort);
//       }
//     }
  
//   //  openDeleteConfirmation(id): void {
//   //     const dialogRef =
//   //       this.dialog.open(DeleteDialogComponent, {
//   //         enterAnimationDuration: '400ms',
//   //         exitAnimationDuration: '500ms',
//   //         data: {
//   //           deleteFunction: () => this.delete(id, dialogRef)
//   //         }
//   //       });
//   //   }

//   onValueChange(data, e): void {
//     const loaderElement = document.getElementById('loader');
//     if (loaderElement) {
//       loaderElement.style.display = 'block';
//     }
    
//     this.usermanagementService.thisRole = data;
//     this.usermanagementService.thisRole.status = (e ? 1 : 0);
//     console.log(this.usermanagementService.thisRole);
    
//     this.usermanagementService.updateRole().then((res) => {
//       this.usermanagementService.getAllRoles().then((res) => {
//         if (loaderElement) {
//           loaderElement.style.display = 'none';
//         }
//       });
//     });
//   }
//   async toggleOrgStatus(data) {
//     try {
//       this.isLoading[data.id] = true;
//       await this.usermanagementService.updateRole().then((res) => {
//         this.toast.success(data.firstName + ' ' + data.lastName + ' status has been updated successfully!', '');
//         this.getAllRoles(data.id);
//       })
//     } catch (error) {
//       this.toast.error('Role cannot be updated!', 'Error');
//     }
//   }
//   customSortData(event: Sort) {
//     const data = this.dataSource.data.slice();
//     if (!event.active || event.direction === '') {
//       this.dataSource.data = data;
//       return;
//     }

//     this.dataSource.data = data.sort((a, b) => {
//       const valueA = (a[event.active] || '').toString().toLowerCase();
//       const valueB = (b[event.active] || '').toString().toLowerCase();

//       return this.compare(valueA, valueB, event.direction === 'asc');
//     });

//     if (this.paginator) {
//       this.paginator.firstPage();
//     }
//   }


//   compare(a: string, b: string, isAsc: boolean) {
//     return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
//   }
// }
